export const formatAddress = (address: string): string => {
  if (!address) return '';
  return `${address.slice(0, 4)}...${address.slice(-4)}`;
};

export const formatUSD = (value: number): string => {
  // Для очень маленьких значений (меньше 1 цента) используем научную нотацию
  if (value > 0 && value < 0.01) {
    return `$${value.toFixed(8)}`;
  }

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};

export const formatTokenAmount = (amount: number, symbol: string): string => {
  // Для очень маленьких чисел (меньше 0.000001) используем научную нотацию
  if (amount > 0 && amount < 0.000001) {
    return `${amount.toExponential(6)} ${symbol}`;
  }

  return `${new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 9,  // Увеличиваем количество знаков после запятой
    useGrouping: true,         // Включаем группировку для больших чисел
    notation: 'standard'
  }).format(amount)} ${symbol}`;
}; 